import { render, staticRenderFns } from "./ModalKonfirmasi.vue?vue&type=template&id=498ef29e&"
import script from "./ModalKonfirmasi.vue?vue&type=script&lang=js&"
export * from "./ModalKonfirmasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports